/*
 * External dependencies
 */
import { computePosition } from '@floating-ui/dom';

import './style.scss';

// Toggle dropdown elements using [data-dropdown-toggle]
document
	.querySelectorAll('[data-dropdown-toggle]')
	.forEach(function (dropdownToggleEl) {
		const dropdownMenuId = dropdownToggleEl.getAttribute(
			'data-dropdown-toggle'
		);
		const dropdownMenuEl = document.getElementById(dropdownMenuId);

		// options
		const placement = dropdownToggleEl.getAttribute(
			'data-dropdown-placement'
		);
		const insideClickClose = dropdownToggleEl.getAttribute(
			'data-dropdown-inside-click-close'
		);

		dropdownToggleEl.addEventListener('click', function (event) {
			let element = event.target;
			while (element.nodeName !== 'BUTTON') {
				element = element.parentNode;
			}

			computePosition(element, dropdownMenuEl, {
				placement: placement ? placement : 'bottom-start',
			}).then(({ x, y }) => {
				Object.assign(dropdownMenuEl.style, {
					left: `${x}px`,
					top: `${y}px`,
				});
			});

			// toggle when click on the button
			dropdownMenuEl.classList.toggle('hidden');
			dropdownMenuEl.classList.toggle('block');

			function handleDropdownOutsideClick(event) {
				const targetElement = event.target; // clicked element

				const isInsideClickClose =
					insideClickClose === 'false' &&
						dropdownMenuEl.contains(targetElement)
						? false
						: true;

				if (
					targetElement !== dropdownMenuEl &&
					targetElement !== dropdownToggleEl &&
					!dropdownToggleEl.contains(targetElement) &&
					isInsideClickClose
				) {
					dropdownMenuEl.classList.add('hidden');
					dropdownMenuEl.classList.remove('block');
					document.body.removeEventListener(
						'click',
						handleDropdownOutsideClick,
						true
					);
				}
			}

			// hide floating ui when clicking outside the element
			document.body.addEventListener(
				'click',
				handleDropdownOutsideClick,
				true
			);
		});
	});
